import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecipientslistComponent } from './recipients-list/recipients-list.component';
import { OneDialogModule, OneSnackBarModule } from '@one/angular-kit/modal';
// import { LearnMoreDialogModule } from '@dia/dialog-reusable-components';
// import { RequestAccessDialogModule } from '@dia/dialog-reusable-components';
// import { FeatureFlagModule } from '@dia/dialog-reusable-components';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CookieService } from 'ngx-cookie-service';
// import { MatFileUploadModule } from 'angular-material-fileupload';
import { FileUploadFeatureModule } from '../fileUpload/file-upload.module';
import { OneFilteringChipModule } from '@one/angular-kit/indicator';
import { OneFormFieldModule, OneSelectDropdownModule, OneEditableDropdownModule } from '@one/angular-kit/form';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RecipientsTableComponent } from './table/recipients-table.component';
import { RecipientsFilterComponent } from './filter/recipients-filter.component';
import { RecipientsSearchComponent } from './search/recipients-search.component';
import { OneTableModule } from '@one/angular-kit/data-table';
import { MatTableModule } from '@angular/material/table';
import { CdkTableModule } from '@angular/cdk/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSortModule } from '@angular/material/sort';
import { ImportDialogFileComponent } from './import-dialog-file/import-dialog-file.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { OneIconModule } from '@one/angular-kit/icon';
import { ImportDialogTableComponent } from './import-dialog-table/import-dialog-table.component';
import { FileUploadService } from '../fileUpload/file-upload/file-upload.service';
import { ImportDiaologTableService } from './import-dialog-table/import-dialog-table.service';
import { RecipientsFilterService } from './filter/recipients-filter.service';
import { MatChipsModule } from '@angular/material/chips';
import { OneChipModule } from '@one/angular-kit/indicator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OneTooltipModule } from '@one/angular-kit/modal';
import { InputValidationDirective } from './import-dialog-file/direcitves/inputboxValidation.directive';
// import { FileUploadComponent } from '../fileUpload/file-upload/file-upload.component';
// import { OneEditableDropdown } from '@one/angular-kit/form';
import { MatPaginatorModule } from '@angular/material/paginator';

@NgModule({
  declarations: [RecipientslistComponent, RecipientsFilterComponent, InputValidationDirective, RecipientsSearchComponent, RecipientsTableComponent, ImportDialogFileComponent, ImportDialogTableComponent],
  exports: [RecipientslistComponent],
  imports: [CommonModule, FileUploadFeatureModule, OneIconModule, MatAutocompleteModule, MatTooltipModule, OneTooltipModule, OneEditableDropdownModule, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, OneFormFieldModule, OneSelectDropdownModule, OneFilteringChipModule, MatCardModule, MatChipsModule, OneChipModule, MatIconModule, MatButtonModule, OneSnackBarModule, /*LearnMoreDialogModule, RequestAccessDialogModule, FeatureFlagModule,*/ OneTableModule, MatTableModule, CdkTableModule, MatCheckboxModule, MatSortModule, OneDialogModule, MatDialogModule, MatPaginatorModule],
  providers: [CookieService, FileUploadService, ImportDiaologTableService, RecipientsFilterService]
})
export class RecipientslistModule {}
